import React from "react";
import * as S from "./style";

const NotFound: React.FC = () => {
  return (
    <S.NotFoundWrapper>
      <div id="particle-container">
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
      </div>
      <div>
        <S.ErrorCode>
          <span>4</span>
          <S.Baloon />
          <span>4</span>
        </S.ErrorCode>
        <S.ErrorMessage>
          <span>Pagina non trovata</span>
          <a href="/" className="btn-continue" role="button">
            <i>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="39.997"
                height="42.5"
                viewBox="0 0 39.997 42.5">
                <path
                  d="M141.683-1401.18l-15.789-14.209a4.33,4.33,0,0,0-5.791,0l-15.789,14.209a3.908,3.908,0,0,0-1.314,2.9V-1378a4.11,4.11,0,0,0,4.212,4H118a1,1,0,0,0,1-1v-14a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v14a1,1,0,0,0,1,1h10.789a4.108,4.108,0,0,0,4.21-4v-20.276a3.908,3.908,0,0,0-1.314-2.9"
                  transform="translate(-103 1416.5)"
                  fill="#fff"
                  fillRule="evenodd"
                />
              </svg>
            </i>
            torna alla home
          </a>
        </S.ErrorMessage>
      </div>
    </S.NotFoundWrapper>
  );
};

export default NotFound;
